import React from "react"
import { Grid } from "@mui/material"
import { DrawerSeeker } from "@ui-seeker/core"
import { autoEuropePricingIdDrawerData, isAutoEuropePricingIdDrawerOpen } from "Pages/AutoEuropeTool/PricingId/@signals"
import AutoEuropePricingIdFooter from "Pages/AutoEuropeTool/PricingId/@components/Footer"
import AutoEuropePricingIdOfficeField from "Pages/AutoEuropeTool/PricingId/@components/OfficeField"
import AutoEuropePricingIdMarketField from "Pages/AutoEuropeTool/PricingId/@components/MarketField"
import AutoEuropePricingIdRecordIdField from "Pages/AutoEuropeTool/PricingId/@components/PricingRecordIdField"
import AutoEuropeOptionalPricingIdField from "Pages/AutoEuropeTool/PricingId/@components/OptionalPricingIdField"

export default function AutoEuropePricingIdDrawer({ onSubmit, isLoading }) {
	return <DrawerSeeker
		title={autoEuropePricingIdDrawerData.value._isEditing ? "Edit Pricing ID" : "Create Pricing ID"}
		anchor="right"
		width="40%"
		variant="persistent"
		isOpen={isAutoEuropePricingIdDrawerOpen.value}
		customFooter={<AutoEuropePricingIdFooter onSubmit={onSubmit} isLoading={isLoading}/>}
	>
		<Grid container spacing={3}>
			<Grid item xs={12}>
				<AutoEuropePricingIdOfficeField/>
			</Grid>
			<Grid item xs={12}>
				<AutoEuropePricingIdMarketField/>
			</Grid>
			<Grid item xs={12}>
				<AutoEuropePricingIdRecordIdField/>
			</Grid>
			<Grid item xs={12}>
				<AutoEuropeOptionalPricingIdField fieldKey="autoeuropeVsMetaId" label="AutoEurope vs Meta ID"/>
			</Grid>
			<Grid item xs={12}>
				<AutoEuropeOptionalPricingIdField fieldKey="cr8VsMetaId" label="CR8 vs Meta ID"/>
			</Grid>
		</Grid>
	</DrawerSeeker>
}